import {
	CurrencyType,
	DiscountTargetType,
	DiscountTermType,
	DiscountType,
	SaleTypeForPlan,
	SaleTypeForTerm,
} from "@/lib/gql/__generated__/graphql";

import type * as DiscountItemOrdinaryShared from "../../../../../_shared";

type InputModel = DiscountItemOrdinaryShared.Model.ModelType.DiscountOrdinaryFormModel["InputModel"];

export const serverModelToInputModelConverter = (
	hotelID: string,
	serverModel: DiscountItemOrdinaryShared.Model.Repository.Query.DiscountOrdinaryNewItemForOrdinaryServerModel,
): InputModel => {
	if (!serverModel.discountOrdinaryNewItem) {
		return {
			hotelID,
			discountID: "",
			// 基本設定
			// 公開・非公開
			inSale: false,
			// ディスカウントの名前
			name: "",
			// ディスカウントの説明
			description: "",
			// ディスカウントのコード
			discountCode: "",
			// ディスカウント金額
			discountType: DiscountType.Ratio,
			ratio: 10,
			// ディスカウント対象
			staticTargetType: DiscountTargetType.PerGroup,
			// ディスカウント対象
			staticTermType: DiscountTermType.PerReservation,
			// 最低提供価格
			resourceLowestPrice: {
				amount: 1000,
				currencyType: CurrencyType.Jpy,
			},
			// ディスカウント対象
			isPlanDiscountEligible: true,
			isRoomDiscountEligible: true,
			isOptionDiscountEligible: true,
			isAdditionalFeeDiscountEligible: true,

			// 追加設定
			// キャンセル不可にするか
			isUncancelable: false,
			// 販売タイプ
			saleTypeForPlan: SaleTypeForPlan.Limited,
			// 利用可能期間
			saleTypeForTerm: SaleTypeForTerm.Always,
		} as InputModel;
	}

	const { discountOrdinaryNewItem } = serverModel;
	return {
		...discountOrdinaryNewItem,
		ratio:
			discountOrdinaryNewItem.discountType === DiscountType.Ratio
				? (discountOrdinaryNewItem.ratio ?? 10)
				: undefined,
		static:
			discountOrdinaryNewItem.discountType === DiscountType.Static
				? (discountOrdinaryNewItem.static ?? {
						amount: 1000,
						currencyType: CurrencyType.Jpy,
					})
				: undefined,
		// サーバーモデルに4つのbooleanフィールドがない場合のデフォルト値
		isPlanDiscountEligible: true,
		isRoomDiscountEligible: true,
		isOptionDiscountEligible: true,
		isAdditionalFeeDiscountEligible: true,
	} as InputModel;
};
